import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
// components
import Button from '../../components/Button/Button';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
// utils
import queryString from 'query-string';
// styles
import styles from './Congratulations.mod.css';
import history from '../../redux/history';

class Congratulation extends Component {
  constructor(props) {
    super(props);
    const { module } = queryString.parse(props.location.search);
    this.finishedModule = module === 'R' ? module : +module || 0;
  }

  handleGoForward = () => {
    this.props.history.push(
      this.finishedModule < 8
        ? `/module/${this.finishedModule + 1}`
        : '/dashboard'
    );
  };

  render() {
    const hasFroward = this.finishedModule !== 'R';
    return (
      <PageWrapper centered>
        <h2 className="mb-0">Congratulations!</h2>
        <h3 className="mt-15">Now you are one step closer to recovery</h3>
        <div className={styles.module}>{this.finishedModule}</div>
        <h3>Module {this.finishedModule} is done!</h3>
        {/*<Button primary className="mt-40" onClick={this.handleGoForward}>*/}
        {hasFroward && (
          <Button
            primary
            className="mt-40"
            onClick={() => history.push('/dashboard')}
          >
            Go forward
          </Button>
        )}
        {/*<br />*/}
        {/*<Link to="/dashboard" className="mt-10">*/}
        {/*  Dashboard*/}
        {/*</Link>*/}
      </PageWrapper>
    );
  }
}

export default withRouter(Congratulation);



// WEBPACK FOOTER //
// ./src/containers/Congratulation/Congratulation.jsx